import { DOCUMENTS_PANE_RAIL_WIDTH } from 'constants/documents';

export const railWrapperStyles = {
  width: `${DOCUMENTS_PANE_RAIL_WIDTH}px`,
  minWidth: `${DOCUMENTS_PANE_RAIL_WIDTH}px`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: ({ palette }) => palette.background.paper,
  flexShrink: 0,
};

export const railLeftBorderStyles = {
  borderRight: ({ palette }) => `1px solid ${palette.divider}`,
};

export const railRightBorderStyles = {
  borderLeft: ({ palette }) => `1px solid ${palette.divider}`,
};

export const expandButtonStyles = {
  width: 32,
  height: 32,
  margin: '8px 0',
};

export const railDividerStyles = {
  width: 24,
  borderColor: ({ palette }) => palette.divider,
};

export const railIconRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  flex: 1,
  paddingTop: '8px',
};

export const railTabButtonStyles = {
  width: 32,
  height: 32,
};

export const railIconWrapStyles = {
  position: 'relative',
  display: 'inline-flex',
};

export const railCountBadgeStyles = {
  position: 'absolute',
  top: '-2px',
  right: '-4px',
  minWidth: '16px',
  height: '16px',
  padding: '0 4px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: 1,
  pointerEvents: 'none',
  backgroundColor: ({ palette }) => palette.primary.main,
  color: ({ palette }) => palette.primary.contrastText,
};

export const railCountBadgeMutedStyles = {
  backgroundColor: ({ palette }) => palette.action.disabledBackground,
  color: ({ palette }) => palette.text.secondary,
};

export const railLabelStyles = {
  writingMode: 'vertical-rl',
  textOrientation: 'mixed',
  transform: 'rotate(180deg)',
  userSelect: 'none',
  paddingBottom: '12px',
  color: ({ palette }) => palette.text.secondary,
  fontSize: '11px',
  letterSpacing: '0.5px',
};
